(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    function splitValues(val) {
      return val.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
    }

    function decodeLower(v) {
      return decodeURIComponent(v.replace(/\+/g, ' ')).toLowerCase();
    }

    function syncButtonActiveState() {
      var params = new URLSearchParams(window.location.search);
      document.querySelectorAll('[data-filter-key][data-filter-value]').forEach(function (btn) {
        var val = btn.getAttribute('data-filter-value');
        var key = btn.getAttribute('data-filter-key');
        if (!key || !val) return;
        var values = splitValues(val).map(decodeLower);
        if (!values.length) return;
        var urlVals = params.getAll(key).map(decodeLower);
        var isActive = values.every(function (v) { return urlVals.indexOf(v) !== -1; });
        // 既存のCSS両方に対応(is-active / qs-active)
        btn.classList.toggle('is-active', isActive);
        btn.classList.toggle('qs-active', isActive);
      });
    }

    function scrollToTarget(btn) {
      var target = btn.closest('.filter-section, .brand-section, .qs-filter') || btn.parentElement;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter-key]');
      if (!btn) return;

      // 同じクリックに対してこの処理が既に一度実行されていたら何もしない
      // (ページ側に残っている個別scriptと二重に動いて、足したものを即消してしまう事故を防ぐ)
      if (e.__filterButtonHandled) return;
      e.__filterButtonHandled = true;

      var key = btn.getAttribute('data-filter-key');
      var val = btn.getAttribute('data-filter-value');
      if (!key || !val) return;

      e.preventDefault();
      e.stopPropagation();

      var originalScrollTo = window.scrollTo;
      var originalScroll = window.scroll;
      var originalScrollBy = window.scrollBy;

      window.scrollTo = function () { };
      window.scroll = function () { };
      window.scrollBy = function () { };

      var originalAnimate;
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.animate) {
        originalAnimate = window.jQuery.fn.animate;
        window.jQuery.fn.animate = function (props) {
          if (props && (props.scrollTop !== undefined || props.scrollLeft !== undefined)) {
            return this;
          }
          return originalAnimate.apply(this, arguments);
        };
      }

      var values = splitValues(val);
      var valuesLower = values.map(decodeLower);

      var params = new URLSearchParams(window.location.search);
      var currentRaw = params.getAll(key);
      var currentDecoded = currentRaw.map(decodeLower);
      var isActive = valuesLower.every(function (v) { return currentDecoded.indexOf(v) !== -1; });

      params.delete(key);
      currentRaw.forEach(function (v, i) {
        if (valuesLower.indexOf(currentDecoded[i]) === -1) params.append(key, v);
      });
      if (!isActive) {
        values.forEach(function (v) { params.append(key, v); });
      }

      var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString().replace(/%2B/gi, '+') : '');

      window.history.pushState(null, '', newUrl);
      window.dispatchEvent(new CustomEvent('boost-sd-url-change', { detail: { url: newUrl } }));
      window.dispatchEvent(new PopStateEvent('popstate', { state: {} }));

      setTimeout(function () {
        window.scrollTo = originalScrollTo;
        window.scroll = originalScroll;
        window.scrollBy = originalScrollBy;
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.animate) {
          window.jQuery.fn.animate = originalAnimate;
        }
        scrollToTarget(btn);
      }, 800);

      syncButtonActiveState();
    });

    window.addEventListener('popstate', syncButtonActiveState);
    document.addEventListener('DOMContentLoaded', syncButtonActiveState);
    setTimeout(syncButtonActiveState, 1000);
  })();
  } catch(e) { console.error(e); }
})();

})();
